import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  FamsAllocationDashboardLatest,
  FamsAllocationHistoryItem,
  FamsStrategyCategoryItem,
  FamsStrategyTargetItem,
  UpdateFamsStrategyPayload,
} from './types/fams-allocation';

const request = createAppRequest();

export async function getFamsAllocationDashboardLatest(
  params?: { parentProjectId?: string; date?: string },
  options?: ApiRequestOptions,
) {
  return request<FamsAllocationDashboardLatest>('/bff/fams/allocation-dashboard/latest', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function getFamsAllocationDashboardHistory(
  params?: { parentProjectId?: string; from?: string; to?: string },
  options?: ApiRequestOptions,
) {
  return request<FamsAllocationHistoryItem[]>('/bff/fams/allocation-dashboard/history', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function generateFamsAllocationDashboard(
  params?: { date?: string },
  options?: ApiRequestOptions,
) {
  return request<{
    snapshotDate: string;
    parents: number;
    facts: number;
    snapshots: number;
    retryCount: number;
  }>('/bff/fams/allocation-dashboard/generate', {
    method: 'POST',
    params,
    ...(options || {}),
  });
}

export async function getFamsAllocationStrategy(options?: ApiRequestOptions) {
  return request<FamsStrategyTargetItem[]>('/bff/fams/allocation-strategy', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function updateFamsAllocationStrategy(
  payload: UpdateFamsStrategyPayload,
  options?: ApiRequestOptions,
) {
  return request<{ effectiveDate: string; version: string; count: number }>(
    '/bff/fams/allocation-strategy',
    {
      method: 'PUT',
      data: payload,
      ...(options || {}),
    },
  );
}

export async function getFamsAllocationStrategyCategories(options?: ApiRequestOptions) {
  return request<FamsStrategyCategoryItem[]>('/bff/fams/allocation-strategy/categories', {
    method: 'GET',
    ...(options || {}),
  });
}
